import { WrappedPatient } from "src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient";
import StartAssessmentsButton from "./StartAssessmentsButton";
import { checkAclValidation } from "src/careflow/ph-core/admin/permissions/util/permission.utils";
import { Card, Stack } from "@mui/material";
import crsAcls from "src/careflow/ph-core/admin/permissions/util/crs/crsAcls";
import SummaryTable from "src/components/SummaryTable";
import { translateTableHead } from "src/careflow/helpers/common";
import { TABLE_HEAD_ASSESSMENTS } from "src/careflow/common/table-head";
import { i18nFunction } from "src/careflow/ph-core/internationalization/hook/useLocales";
import { AssessmentsFormsResponse, ReferralService } from "src/crs/referral/services/ReferralService";
import { useEffect, useState } from "react";
import { mapAssessmentsForms } from "src/careflow/common/common-utils";

type Props = {
  patient: WrappedPatient | null;
  i18n: i18nFunction;
}

export const AssessmentList = ({ patient, i18n }: Props ) => {
  const [assessmentsForms, setAssessmentsForms] = useState<AssessmentsFormsResponse[]>([]);

  const fetchAssessments = async () => {
    const result: any = await ReferralService.assessmentsByPatient(patient?.id);
    setAssessmentsForms(mapAssessmentsForms(result));
  };

  useEffect(() => {
    fetchAssessments();
  }, [patient]);

  return (
    <Card style={{ boxShadow: 'none', position: 'static' }} sx={{ m: 0 }}>
      <Stack sx={{ m: 0 }}>
        {checkAclValidation({
          acls: [crsAcls.CRS.PATIENT.ASSESSMENTS.START],
        }) && (
          <StartAssessmentsButton
            keyRegistry="crs-patient-assessments"
            patientId={patient?.id ?? ''}
          />
        )}
      </Stack>
      <SummaryTable
        header={translateTableHead(TABLE_HEAD_ASSESSMENTS, i18n, 'crs')}
        data={assessmentsForms}
      />
    </Card>
  )
};